import React from 'react'

export const CommonHeading = (props) => {
  return (
    <div>
        <h1 className='CommonHeadings'>{props.text}</h1>
    </div>
  )
}
